export enum Role {
  CANDIDATE = 'candidate',
  EMPLOYEE = 'employee',
  RECRUITER = 'recruiter',
  ADMIN = 'admin',
  FIND_TALENT='findTalent'
}
